/* eslint react/prop-types: 0, react/display-name: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { QueryRenderer, graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import CartLoading from './CartLoading';
import CartError from './CartError';
import CartContainer from './CartContainer';
import CartLoggedOut from './CartLoggedOut';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';

class CartRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: getBuyerId(document.cookie),
        };
    }
    componentDidMount() {
        addLoginHandlers(() => {
            this.setState({ userId: getBuyerId(document.cookie) });
        });
    }
    render() {
        const { relayEnvironment } = this.props;
        const { userId } = this.state;

        if (!userId) {
            return <CartLoggedOut />;
        }

        return (
            <QueryRenderer
                Container={CartContainer}
                environment={relayEnvironment}
                query={graphql`
                    query CartRendererQuery(
                        $userId: String!
                        $userIds: [String]!
                        $hasUserId: Boolean!
                    ) {
                        viewer {
                            ...CartContainer_viewer
                            user(userId: $userId) {
                                ...CartContainer_user
                            }
                        }
                    }
                `}
                variables={{
                    userId,
                    userIds: [userId],
                    hasUserId: !!userId,
                }}
                render={({ error, props }) => {
                    if (error) {
                        return <CartError />;
                    } else if (props) {
                        return <CartContainer viewer={props.viewer} user={props.viewer.user} />;
                    } else {
                        return <CartLoading isStaticLoading />;
                    }
                }}
            />
        );
    }
}

CartRenderer.propTypes = {
    relayEnvironment: PropTypes.object.isRequired,
};

export default CartRenderer;
